import React from 'react';
import QRCode from 'qrcode.react';
import { useParams } from 'react-router-dom';


import '../stylesheet/endPage.css'

export default function EndPage() {
    const { theatre,timing } = useParams();
    
    console.log(theatre,timing)
    const bookingId = Math.random().toString(36).substring(7); // Generate a random string for booking ID

    return (
        <div className='mainn'> 
            <div className="booking-confirmation">
            
            <h1 className="titlee">Booking Confirmation</h1>
            <p className="message">Your booking at {theatre} is confirmed! Please visit before {timing}</p>


            <QRCode value={bookingId} className="qr-code" />
            <p className="booking-id">Here is your booking QR code: {bookingId}</p>
            </div>
        </div>
    );
    }